import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const QualityCourseStyle = withTheme(styled.div`
  padding: 10px 0px;
  background-color: #f5f5f5;
  .container {
    max-width: 1182px;
    margin: 40px auto;
    padding: 0px 20px;
  }
  .logo-group {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .logo-tii {
    width: 72px;
    height: 81px;
    margin: 0px 28px;
  }
  .logo-tip {
    width: 83px;
    height: 80px;
    margin: 0px 28px;
  }
  .logo-skilllanecpd {
    width: 137px;
    height: 46px;
    margin: 0px 28px;
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    text-align: center;
    .logo-group {
      justify-content: center;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    padding: 5px 0px;
    .container {
      padding: 0px 16px;
    }
    .topic {
      font-size: 24px;
      line-height: 24px;
    }
    .sub-topic {
      font-size: 18px;
      line-height: 22px;
    }
    .logo-tii {
      width: 49px;
      height: 56px;
      margin: 0px 15px;
    }
    .logo-tip {
      width: 62px;
      height: 60px;
      margin: 0px 15px;
    }
    .logo-skilllanecpd {
      width: 90px;
      height: 30px;
      margin: 0px 15px;
    }
  }
`);

export default QualityCourseStyle;
